import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import SchoolTwoToneIcon from '@mui/icons-material/SchoolTwoTone';
const LandingHomePage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
        px: 2,
        textAlign: 'center'
      }}
    >
      <SchoolTwoToneIcon sx={{ fontSize: 80, mb: 2 }} color='inherit' />
      <Typography variant="h3" gutterBottom>
        Welcome
      </Typography>
      <Typography variant="h6" color="text.secondary">
        Simplified time tracking software
      </Typography>
    </Box>
  );
};

export default LandingHomePage;